// IE Hub - Application Version Info
// Centralised, typed access to the app version for display in the UI.

import { PUBLIC_ENV } from "./env";

export interface UU_SHOW_HIDE_INFO {
  readonly uuShowHideInfo: boolean;
}

export const UU_SHOW_HIDE_INFO: UU_SHOW_HIDE_INFO = {
  uuShowHideInfo: false,
};
